import React from "react";
import Skeleton from "../../Common/Skeleton";


export const MarketPricesTableSkeleton = () => {
  return (
    <Skeleton className="flex flex-col overflow-hidden p-0 font-outfit rounded-2xl">
      {/* Table Header / Subtitle */}
      <div className="flex h-[54px] shrink-0 items-center justify-between border-b border-divider px-4 pb-[17px] pt-4">
        <Skeleton className="h-4 w-28 rounded-md" />
        <Skeleton className="h-3 w-16 rounded-md" />
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px] border-collapse">
          <thead>
            <tr className="border-b border-divider">
              <th className="px-5 py-4 text-left">
                <Skeleton className="h-3 w-4 rounded-md" />
              </th>
              <th className="py-4 pr-3 text-left">
                <Skeleton className="h-3 w-16 rounded-md" />
              </th>
              <th className="px-3 py-4 text-left">
                <Skeleton className="h-3 w-12 rounded-md" />
              </th>
              <th className="px-3 py-4 text-right">
                <Skeleton className="h-3 w-10 ml-auto rounded-md" />
              </th>
              <th className="px-3 py-4 text-right">
                <Skeleton className="h-3 w-10 ml-auto rounded-md" />
              </th>
              <th className="px-3 py-4 text-right">
                <Skeleton className="h-3 w-10 ml-auto rounded-md" />
              </th>
              <th className="px-3 py-4 text-left">
                <Skeleton className="h-3 w-20 rounded-md" />
              </th>
              <th className="px-3 py-4 text-left">
                <Skeleton className="h-3 w-24 rounded-md" />
              </th>
              <th className="px-5 py-4 text-right">
                <Skeleton className="h-3 w-20 ml-auto rounded-md" />
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 }).map((_, index) => (
              <tr
                key={index}
                className={index < 7 ? "border-b border-divider" : ""}
              >
                {/* # Rank */}
                <td className="px-5 py-3">
                  <Skeleton className="h-4 w-4 rounded-md" />
                </td>

                {/* Logo & Asset Name */}
                <td className="py-3 pr-3">
                  <div className="flex items-center gap-2.5">
                    <Skeleton className="size-6 !rounded-full shrink-0" />
                    <Skeleton className="h-4 w-24 rounded-md" />
                  </div>
                </td>

                {/* Price */}
                <td className="px-3 py-3">
                  <Skeleton className="h-4 w-20 rounded-md" />
                </td>

                {/* 1h % */}
                <td className="px-3 py-3 text-right">
                  <Skeleton className="h-4 w-12 rounded-md ml-auto" />
                </td>

                {/* 24h % */}
                <td className="px-3 py-3 text-right">
                  <Skeleton className="h-4 w-12 rounded-md ml-auto" />
                </td>

                {/* 7d % */}
                <td className="px-3 py-3 text-right">
                  <Skeleton className="h-4 w-12 rounded-md ml-auto" />
                </td>

                {/* Market Cap */}
                <td className="px-3 py-3">
                  <Skeleton className="h-4 w-28 rounded-md" />
                </td>

                {/* Volume (24h) - 2 lines */}
                <td className="px-3 py-3">
                  <div className="space-y-1.5">
                    <Skeleton className="h-4 w-28 rounded-md" />
                    <Skeleton className="h-3 w-16 rounded-md" />
                  </div>
                </td>

                {/* Last 7 Days Sparkline */}
                <td className="px-5 py-3 text-right">
                  <Skeleton className="h-7 w-24 rounded-md ml-auto" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Skeleton>
  );
};

export default MarketPricesTableSkeleton;